import { AppLayout, CatEdgeConfigProvider } from '../catedge';

import { useAuthStore } from '@/platform/stores/useAuthStore';
import { AdminWorkspaceProvider } from '../adapters/AdminWorkspaceProvider';
import { CatEdgeAuthProvider } from '../adapters/CatEdgeAuthProvider';
import { createAdminShellConfig } from '../config/adminShellConfig';

export default function AdminShell() {
  const capabilities = useAuthStore((state) => state.user?.adminSummary?.capabilities ?? []);
  const config = createAdminShellConfig(capabilities);

  return (
    <CatEdgeConfigProvider config={config}>
      <CatEdgeAuthProvider>
        <AdminWorkspaceProvider>
          <AppLayout />
        </AdminWorkspaceProvider>
      </CatEdgeAuthProvider>
    </CatEdgeConfigProvider>
  );
}
